import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonData } from '../buttons/buttons.component';

export interface SectionAnchorBannerData {
  description: string;
  link: string;
  image: string;
  modal: string;
  buttons: Array<ButtonData>;
}

@Component({
  selector: 'fcp-section-anchor-banner',
  templateUrl: './section-anchor-banner.component.html',
  styleUrls: ['./section-anchor-banner.component.scss']
})
export class SectionAnchorBannerComponent {

  @Input() public sectionAnchorBanner: SectionAnchorBannerData;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  public heightHeader = 77;

  public emitClick(btn: any): void {
    if (btn) {
      this.wasButtonClicked.emit(btn);
    }
  }

  public goToNext($element): void {
    const elementPositionTop = $element['offsetTop'] - this.heightHeader;
    window.scrollTo(0, elementPositionTop);
  }

  public goToTop(): void {
    window?.scrollTo(0, 0);
  }


}
